export const DEFAULT_OPTIONS = {
  overrideSystem: false,
  ignoreInputFields: true,
  repeatOnHold: true,
};

export const BLACKLISTED_DOM_TARGETS = ['TEXTAREA', 'INPUT'];
